import { useCallback } from 'react';
import { shallow } from 'zustand/shallow';
import { useStoreWithEqualityFn } from 'zustand/traditional';

import { selectData, selectById, selectIsLoading } from '../selectors.ts';
import { useAttach } from '../useAttach';

import { flowCardTriggersStore, type FlowCardTriggersStoreState } from './FlowCardTriggersStore.ts';

export function useFlowCardTriggersData() {
  useAttach(flowCardTriggersStore, 'useFlowCardTriggersData');
  return useStoreWithEqualityFn(flowCardTriggersStore.store, selectData, shallow);
}
useFlowCardTriggersData.store = flowCardTriggersStore;

export function useFlowCardTriggersById() {
  useAttach(flowCardTriggersStore, 'useFlowCardTriggersById');
  return useStoreWithEqualityFn(flowCardTriggersStore.store, selectById, shallow);
}
useFlowCardTriggersById.store = flowCardTriggersStore;

export function useFlowCardTrigger({ flowCardTriggerId }: { flowCardTriggerId: string }) {
  useAttach(flowCardTriggersStore, 'useFlowCardTrigger');

  const select = useCallback(
    (state: FlowCardTriggersStoreState) => {
      return {
        flowCardTrigger: state.byId?.[flowCardTriggerId] ?? null,
        flowCardTriggerInstance: state.data?.[flowCardTriggerId] ?? null,
        isLoading: state.isLoading,
        error: state.error,
      };
    },
    [flowCardTriggerId],
  );

  return useStoreWithEqualityFn(flowCardTriggersStore.store, select, shallow);
}
useFlowCardTrigger.store = flowCardTriggersStore;

export function useFlowCardTriggersAttach() {
  useAttach(flowCardTriggersStore, 'useFlowCardTriggersAttach');
}
useFlowCardTriggersAttach.store = flowCardTriggersStore;

export function useFlowCardTriggersLoading() {
  useAttach(flowCardTriggersStore, 'useFlowCardTriggersLoading');
  return useStoreWithEqualityFn(flowCardTriggersStore.store, selectIsLoading, Object.is);
}
useFlowCardTriggersLoading.store = flowCardTriggersStore;
